import React from 'react';
import { UserImpersonationControls } from './UserImpersonationControls';
import type { AdminCompanyMerchant } from '../../../models/adminCompany';

export interface MerchantListSectionProps {
  merchants: AdminCompanyMerchant[];
}

/** Company-scoped merchant list (name, email, status) fed by the admin company detail response. */
export function MerchantListSection({ merchants }: MerchantListSectionProps): React.ReactElement {
  return (
    <div className="bo-card">
      <div className="bo-admin-table-head">
        <h2 className="bo-admin-section-title">Merchants</h2>
        <p className="bo-muted">Merchants linked to this company.</p>
      </div>
      {merchants.length === 0 ? (
        <p className="bo-muted">No merchants are linked to this company yet.</p>
      ) : (
        <div className="bo-admin-table-wrap">
          <table className="bo-admin-table">
            <thead>
              <tr>
                <th>Merchant</th>
                <th>Email</th>
                <th>Status</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {merchants.map((merchant) => {
                const isActive = merchant.status.toLowerCase() === 'active';
                return (
                  <tr key={merchant.merchantId}>
                    <td>
                      <strong>{merchant.name || '—'}</strong>
                    </td>
                    <td>{merchant.email || '—'}</td>
                    <td>
                      <span className={`bo-status-pill ${isActive ? 'bo-status-active' : 'bo-status-inactive'}`}>
                        {merchant.status}
                      </span>
                    </td>
                    <td>
                      <div className="bo-actions">
                        <UserImpersonationControls
                          targetUserId={merchant.userId}
                          displayName={merchant.name || merchant.email}
                          disabled={merchant.banned}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
